// Auto-generated by scripts/generate-version.js
export const UI_VERSION = "3.3.2.19";
export const BUILD_TIME_ISO = "2026-09-24T12:20:30.224Z";
